<div class="sub-tenants default-content">
  <h3 class="text-uppercase"><small><strong i18n="@@components.tenant_settings.sub_tenants">Sub Tenants</strong></small></h3>
  <div id="tenant-search-container" class="tenant-search-container me-1 mb-3">
    <div class="input-group input-group-xs">
      <span class="input-group-text">
        <fa-icon [icon]="['fas', 'university']" [fixedWidth]="true"></fa-icon>
      </span>

      <input type="text"
        class="form-control tenant-search"
        autocomplete="off"
        i18n-placeholder="@@sub_tenants.add_sub_tenant"
        placeholder="Add sub-tenant"
        [(ngModel)]="searchTenant"
        [typeahead]="allowedSubTenants"
        [typeaheadOptionsLimit]="10"
        [typeaheadMinLength]="0"
        [typeaheadIsFirstItemActive]="false"
        (typeaheadOnSelect)="onSelectTenant($event)"
        (typeaheadOnBlur)="typeaheadOnBlur()"
        typeaheadOptionField="name"
        container="body"
        >
    </div>
  </div>
  @if (currentSubTenants && currentSubTenants.length > 0) {
    <div class="sub-tenants-grid">
      @for (tenant of currentSubTenants; track tenant; let i = $index) {
        <span class="badge-tenant">
          <fa-icon [icon]="['fas', 'university']"
            [fixedWidth]="true"
            class="me-1">
            </fa-icon>{{ tenant.name }}<span (click)="unlinkTenant(i, tenant)" class="times pointer ms-1">&times;</span>
          </span>
          @if ((i + 1) % 3 === 0) {
            <div class="row-break"></div>
          }
        }
      </div>
    }
  </div>
